import { render, staticRenderFns } from "./SportelloTipiContrattoView.vue?vue&type=template&id=0542eaae&"
import script from "./SportelloTipiContrattoView.vue?vue&type=script&lang=ts&"
export * from "./SportelloTipiContrattoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports